export interface LandingPageOption {
  label: string;
  route: string;
}

export const LANDING_PAGE_CONFIG: Record<string, LandingPageOption[]> = {
  VIEW_PATIENTS: [
    { label: 'Patient Appointment Dashboard', route: '/admin/dashboard' }
  ],

  SECURE_MESSAGE: [
    { label: 'Secure Message', route: '/admin/messages' }
  ],

  MANAGE_TASK: [
    { label: 'Task List', route: '/admin/tasklist' }
  ],

  ACCOUNT_MANAGEMENT: [
    { label: 'Account Management Requests', route: '/admin/requests' }
  ],

  CONVERSATIONS_INSIGHT: [
    { label: 'Conversation List', route: '/admin/conversations' }
  ],

  REVIEW_DOCUMENTS: [
    { label: 'Documents Review', route: '/admin/documents' }
  ],

  USER_MANAGEMENT: [
    { label: 'User Management', route: '/admin/practice/manage/users-list' }
  ],

  PATIENT_DATABASE: [
    { label: 'Patient Database', route: '/admin/patient/report' }
  ],

  PATIENT_ONBOARDING_DATABASE: [
    { label: 'Onboarding Tracker List', route: '/admin/patient/onboarding' }
  ],

  MANAGE_REFPOD: [
    { label: 'REFPOD', route: '/admin/officelist' }
  ],

  MWISE_FEEDBACK: [
    { label: 'M-Wise Feedback Ratings', route: '/admin/mdac/feedback-rating' }
  ],

  MW_ANALYTICS_REF_SOURCE: [
    { label: 'Referral Source', route: '/admin/mdac/source-dashboard' }
  ],

  VIEW_SYSTEM_MONITORING: [
    { label: 'Application Health', route: '/admin/application/health' }
  ],

  VIEW_SYNC_JOBS: [
    { label: 'Patient Sync Jobs', route: '/admin/jobs/report' }
  ],

  MANAGE_CLINICAL_VISITS: [
    { label: 'Clinical Visits', route: '/admin/appointments' }
  ],

};